<div class="payment__popup">
    <div class="modal-header">
        <div class="modal-title" *ngIf="!isFromUnlock">
            <span>Purchase Your Valuation Report</span>
        </div>
        <div class="modal-title" *ngIf="isFromUnlock">
            <span>Unlock The Report</span>
        </div>
        <button id="payment-close-btn" type="button" class="close" aria-label="Close" (click)="cancel()">
            <span aria-hidden="true"></span>
        </button>
    </div>

    <div class="modal-body">
        <div class="offer__text">
            {{isFromUnlock ? 'Unlock' : 'Buy'}} <span class="color--blue">the report</span> for a one-time fee of
          <span class="color--blue {{promo ? 'greyish strikeText' : null}}">${{basePrice}}</span>
          <ng-container *ngIf="promo">
            <span class="color--blue"> ${{payableAmount}}</span> with promo code <span class="color--blue">{{promo}}</span>
          </ng-container>
        </div>
        <div class="small__text text-left">
            With ability to edit all information in the current report for 30 days after report generation
        </div>

        <div class="text-center">
            <button id="payment-buy-report" type="button" class="button secondary__button large__button my-4 px-5"
                (click)="gotoBillingPage()">
                Buy the Report
            </button>
            <ng-container *ngIf="!isFromUnlock">
                <br>
                <button id="sample-report-button" type="button" class="button secondary__button large__button mb-4 px-4"
                    (click)="downloadSample()" [disabled]="sampleBtnDisable">
                    See a Sample Report
                </button>
            </ng-container>
        </div>

        <div class="small__text text-left">
            You now will have the ability to edit this report for the next 30 days. After the report expires, you will
            have the ability to unlock and edit it for an additional ${{promo ? calcRenewPrice : renewPrice}}.
        </div>
    </div>
</div>
